import { Injectable } from '@angular/core';
import { BaseService } from '../base/base.service';
import { environment } from 'src/environments/environment';
import { HttpClient } from '@angular/common/http';
import { JobsForAssetResult } from 'src/app/property/models/jobs-for-asset-count.model';
import { JobsForAsset } from 'src/app/property/models/jobs-for-asset.model';
import { Assets } from 'src/app/shared/models/assets-register/assets.model';
import { BehaviorSubject, Observable } from 'rxjs';
import { AddAutoAsset } from 'src/app/shared/models/assets-register/add-assets.model';
import { PropertyAssetInvitationModel } from 'src/app/property/models/send-tenat-asset-link-email.model';
import { SendTenatToAssetLinkEmail } from 'src/app/shared/models/assets-register/send-tenat-asset-link-email.model';
import { JobAssetRecommendationModel } from '../../../../property/models/job-asset-recommendations.model';
import { SmartAssetRecommendation,SmartAssetRecommendationResults} from 'src/app/layout/models/smart-asset-recommendation';
import { AssetDetailsModel, AssetStatusCategories } from 'src/app/asset/models/asset.model';
import { AssetModel,AssetForRecommendationModel } from 'src/app/property/models/new-asset.model';
@Injectable({
  providedIn: 'root'
})
export class JobAssetService extends BaseService {

  private readonly urlPrefix = `${environment.maintenance.urlPrefix}/job/assets`;
  public assetsDetailsForJobProperty$ = new BehaviorSubject<AssetModel>(null);
  assets$ = this.assetsDetailsForJobProperty$.asObservable();

  constructor(http: HttpClient) {
    super(http);
  }

  getJobsForAssetByPropertyId(propertyId: string) {
    return this.get<JobsForAssetResult[]>(`${this.urlPrefix}/jobs-for-asset?PropertyId=${propertyId}`)
  }

  getJobsForAsset(assetId: string) {
    return this.get<JobsForAsset[]>(`${this.urlPrefix}/jobs-for-asset-history?assetId=${assetId}`)
  }
  getAssetsForPropertyJob(jobId: string) {
    return this.get<Assets[]>(`${this.urlPrefix}/assets-for-property-job?jobid=${jobId}`)
  }
   
  addAutoAsset(asset: AddAutoAsset) {
    return this.post<any>(`${this.urlPrefix}/auto-add-assets-assestforjob`, asset);
  }
  getScannedAssetData(description: string,imageUrls: string|null){
    return this.get<any>(
      `${this.urlPrefix}/scanned-assets?description=${description}&imageUrls=${imageUrls}`
    );
  }
  getJobAssetRecommendations(pageNumber: number) {
    return this.get<SmartAssetRecommendationResults>(`${this.urlPrefix}/assets-recommendations?pageNumber=${pageNumber}`)
  }
  viewAsset(assetId: string){
    return this.get<AssetForRecommendationModel>(`${this.urlPrefix}/view-asset?assetId=${assetId}`);
  }
  editAssets(assets: AssetModel) {
    this.assetsDetailsForJobProperty$.next(assets); 
  }
}
